import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../../components/sidebar'
import Footer from '../../components/footer'
import Head from '../../components/head'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's CSS for styling
import { BiSolidSave } from "react-icons/bi";
import { FaDeleteLeft } from "react-icons/fa6";
import { IoIosAddCircle } from "react-icons/io";
import { api } from '../../api'

export default function Main() {

  const [view,setview]=useState([])
  const [status,setStatus]=useState([])
  const [blogId,setBlogsID]=useState("")
  
  useEffect(() => {
    get();
  }, []);

  const get =()=> {

    const queryParams = new URLSearchParams(window.location.search)
    const id = queryParams.get("id")
    setBlogsID(id)
    getAllView(id)
    getStatus()
    };

  const addContact_section = async ()=> {
    const data = new FormData();
    data.append('blogs_id',blogId);
    data.append('contant','');
    data.append('tag','img');
    data.append('ex','');
    data.append('status','s');

            axios({
              method: 'post',
              url:'/api/royal_blogs/content/add.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                console.log(s.data)
                getAllView(blogId)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const getAllView = async (id)=> {
    const data = new FormData();    
    data.append('blogs_id',id);

            axios({
              method: 'post',
              url:'/api/royal_blogs/content/view.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setview(s.data)
                console.log(s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const getStatus = async ()=> {
    const data = new FormData();
    data.append('id',blogId);

            axios({
              method: 'post',
              url:'/api/royal_blogs/content/contant_status.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setStatus(s.data)
                console.log("status : ", s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };
  const updateIById = (id, tag) => {
    setview(prevItems =>
      prevItems.map(item =>
        item.id === id ? { ...item, tag: tag } : item
      )
    );
  };

  const updateView = (id, key,value) => {
    setview(prevItems =>
      prevItems.map(item =>  item.id === id ? { ...item, [key]: value } : item )
    );
  };

  const Update_section = async (index)=> {
    const data = new FormData();
    data.append('blogs_id',blogId);
    data.append('contant',view[index].contant);
    data.append('tag',view[index].tag);
    data.append('ex',view[index].ex);
    data.append('status',view[index].status);
    data.append('id',view[index].id);

            axios({
              method: 'post',
              url:'/api/royal_blogs/content/update.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {

                console.log("update by id server",s.data)
                getAllView(blogId)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const Delete = async (index)=> {
    const data = new FormData();
    data.append('id',view[index].id);
            axios({
              method: 'post',
              url:'/api/royal_blogs/content/delete.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {

                console.log("update by id server",s.data)
                getAllView(blogId)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };
          const handleDelete = (index) => {
            if (window.confirm("Are you sure you want to delete this?")) {
              // Proceed with delete logic
              console.log("Item deleted.");
              Delete(index)
            } else {
              console.log("Deletion cancelled.");
            }
          };
  return (
    <>
     <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
       <Head />
       <div>
    
        <div className="page-content">
        <div className="row">
        <div  className="col-md-12">

      {
        view.map((v,index)=>(
          <div key={index} className="card  p-1 mb-1">  
          <div className="card-body">
            <div className='row'>
            <div className='col-2'>
            
            <select value={v.tag}  onChange={(e)=>(updateIById(v.id,e.target.value))} className="form-control">
              <option></option>
              {
                status.map((vv,ii)=>(
                  <>
                  <option key={ii+index} value={vv.value}>{vv.name}</option>
                  </>
                ))
              }
            </select>
                </div>


              <div className='col-1'>
              <button onClick={(d)=>{ Update_section(index)}}  className="btn btn-primary "> <BiSolidSave /> </button>
                </div>
              <div className='col-1'>
              <button onClick={(d)=>{ handleDelete(index)}}  className="btn btn-primary "> <FaDeleteLeft /> </button>
                </div>
            </div>

            {
              v.tag=="content"?<>
              <br/>
              <div className='mb-2'>
              <ReactQuill
                       theme="snow"
                       value={v.contant}
                       onChange={(e)=>(
                        updateView(v.id,"contant",e)
                       )}
                      className='mb-2'
                       modules={{
                         toolbar: [
                           [{ header: [1, 2, 3, 4, false] }], // Headers
                           [{ font: [] }], // Font family
                           [{ size: [] }], // Font size
                           ['bold', 'italic', 'underline', 'strike', 'blockquote'], // Basic styling
                           [
                             { color: [] }, 
                             { background: [] }
                           ], // Text color and background color
                           [{ script: 'sub' }, { script: 'super' }], // Subscript / Superscript
                           [{ list: 'ordered' }, { list: 'bullet' }], // Lists
                           [{ align: [] }], // Text alignment
                           ['link', 'image', 'video'], // Media links
                           ['clean'], // Clear formatting
                         ],
                       }}
                       formats={[
                         'header', 'font', 'size',
                         'bold', 'italic', 'underline', 'strike', 'blockquote',
                         'color', 'background',
                         'script', 'list', 'bullet',
                         'align', 'link', 'image', 'video',
                       ]}
                       style={{ height: '300px', width: '1000px' }}
                     />
                </div>
                     </>:<>
                     <br/>
                <input
                  type="text"
                  className="form-control"
                  
                  autoComplete="off"
                  placeholder="Img url"
                  value={v.contant}
                  onChange={(e)=>(
                   updateView(v.id,"contant",e.target.value)
                  )}
                />
              
              </>
            }
          </div>
        </div>
        ))
      }
    </div>
  </div>
  <div className="float-end"><button onClick={addContact_section}  className="btn btn-primary p-2 m-2"> <IoIosAddCircle />  </button></div>
</div>
    </div>
        <Footer/>
      </div>
    </div>
 
  </>

  )
}
